import { render, staticRenderFns } from "./tag_table.vue?vue&type=template&id=5464ee2e"
import script from "./tag_table.vue?vue&type=script&lang=js"
export * from "./tag_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports